import { AppThunk } from "../index";
import { api } from "../../services/Api";
import {
    setCustomerUploadStatus,
    setCustomerUploadData,
    setCustomerUploadError,
} from "../reducers/CustomerUploadReducer";
import { getCustomerUploadData } from "../selectors/CustomerUploadSelectors";

export const uploadCustomerImageAction =
    (formData: FormData): AppThunk =>
        (dispatch, getState) => {
            dispatch(setCustomerUploadStatus("loading"));

            api
                .upload(`/upload-client-image`, formData)
                .then((response) => {
                    const currentUploadData = getCustomerUploadData(getState());
                    dispatch(
                        setCustomerUploadData({
                            ...currentUploadData,
                            ...response
                        })
                    );
                })
                .catch((error) => {
                    dispatch(setCustomerUploadError(error.message || "Upload failed"));
                    dispatch(setCustomerUploadData(null));
                });
        };